import React from 'react';
import { UniversalCalculator } from './UniversalCalculator';
import { lumpsumUniversalConfig } from './universalCalculatorConfigs';

export const LumpsumCalculator: React.FC = () => {
  return <UniversalCalculator config={lumpsumUniversalConfig} />;
};
